<div
  class="page-container"
  [ngStyle]="{
    '--color50': category.color50,
    '--color0': category.color0,
    '--color70': category.color70,
    '--color80': category.color80,
    '--color90': category.color90,
  }">
  <div class="header background-transparent">
    <span class="font-bold-display-medium title-color"> Zahlungsdetails </span>
    <span class="font-regular-title-large font-color-black">
      Du hast die Zahlungsmethode Banküberweisung ausgewählt.
    </span>
  </div>
  <div class="flex-c gap-24">
    <div class="flex-c gap-12 padding-16-0">
      <span class="font-medium-headline-medium title-color">
        1. Überweisung durchführen
      </span>
      <div class="font-regular-body-large font-color-black">
        Du solltest den Betrag von
        <strong>{{ totalAmount | currency: 'EUR' }}</strong> auf folgendes
        Bankkonto einzahlen. Vorzugsweise mit denselben
        Rechnungsanschriftendaten.
      </div>
    </div>
    <div class="card font-color-black">
      <div class="card-title title-color">
        <i class="fa-regular fa-credit-card"></i>
        <span class="font-medium-title-large">Überweisungsinformationen</span>
      </div>
      <div class="flex-c gap-4">
        <span>Kontoinhaber: Institut Wissen gUG</span>
        <span>IBAN: DE84 6645 1548 0000 6241 31</span>
        <span>Bankname: Sparkasse Kinzigtal</span>
      </div>
      <div class="bank-divider" role="separator" aria-hidden="true">
        <span>oder</span>
      </div>
      <div class="flex-c gap-4">
        <span>Kontoinhaber: Vanessa Marie Diel</span>
        <span>IBAN: DE72 1001 1001 2364 2106 55</span>
        <span>Bankname: N26</span>
      </div>
    </div>
    <div class="flex-c gap-12 padding-16-0">
      <span class="font-medium-headline-medium title-color">
        2. Zugang erhalten
      </span>
      <div class="font-regular-body-large font-color-black">
        <span>
          Sobald die Zahlung bei uns eingegangen ist, wird Dein Seminar-Zugang
          freigeschaltet und Du hast Zugriff auf alle dazugehörigen Dokumente.
          Du erhältst dann nochmal eine separate E-Mail, die Dich über die
          Freischaltung informiert.
        </span>
        <br />
        <span>
          Bitte beachte, dass der Vorgang den Abläufen der Banken unterliegt (
          Feiertage, Wochenenden, Verzögerung etc.)
        </span>
      </div>
    </div>
  </div>
</div>
